export default function formatPrice(price: number, currency: string, locales?: Intl.LocalesArgument) {
	const numberFormat = new Intl.NumberFormat(locales ?? navigator.languages, {
		style: 'currency',
		currency,
	});
	const formattedPrice = numberFormat.format(price / 1000);
	return formattedPrice;
}
